import { Button } from '@/components/ui/button'
import { CopyButton } from '@/components/ui/CopyButton'
import { Label } from '@/components/ui/label'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

interface Credentials {
  clientId: string
  clientSecret: string
}

interface CredentialsDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  credentials: Credentials | null
  title?: string
}

export function CredentialsDialog({
  open,
  onOpenChange,
  credentials,
  title = 'Credentials Generated',
}: CredentialsDialogProps) {
  const handleClose = () => {
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent
        onInteractOutside={e => e.preventDefault()}
        onEscapeKeyDown={e => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle className="mb-3">{title}</DialogTitle>
          <DialogDescription className="px-3">
            Save these credentials. The client secret will not be shown again.
          </DialogDescription>
        </DialogHeader>
        {credentials && (
          <div className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="client-id" className="mx-3">
                Client ID
              </Label>
              <div className="flex items-center gap-2">
                <input
                  id="client-id"
                  type="text"
                  value={credentials.clientId}
                  readOnly
                  className="flex-1 px-3 py-2 text-sm border rounded-md font-mono bg-muted"
                />
                <CopyButton value={credentials.clientId} />
              </div>
            </div>
            <div className="space-y-2 pb-4">
              <Label htmlFor="client-secret" className="mx-3">
                Client Secret
              </Label>
              <div className="flex items-center gap-2">
                <input
                  id="client-secret"
                  type="text"
                  value={credentials.clientSecret}
                  readOnly
                  className="flex-1 px-3 py-2 text-sm border rounded-md font-mono bg-muted"
                />
                <CopyButton value={credentials.clientSecret} />
              </div>
            </div>
            <Button onClick={handleClose} className="w-full">
              I've saved the credentials
            </Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  )
}
